import React from "react";
import styled from "styled-components";
import SEO from "../components/SEO";

export default function BookingPage() {
  const bookingUrl =
    "https://outlook.office.com/owa/calendar/bookings@shift-it.io/bookings/";
  return (
    <Page>
      <SEO
        title="Book a Fit Check | Shift IT"
        description="Schedule a 15-minute Fit Check with Shift IT to align on priorities, scope, and the next step that makes sense."
        canonical="https://shift-it.io/booking"
      />
      <FrameWrap>
        <BookingFrame
          src={bookingUrl}
          scrolling="yes"
          title="Shift IT Booking"
        />
      </FrameWrap>
    </Page>
  );
}

const Page = styled.div`
  background: #eeeeee;
  min-height: 100vh;
`;

const FrameWrap = styled.div`
  width: 100vw;
  height: 100vh;
`;

const BookingFrame = styled.iframe`
  width: 100%;
  height: 100%;
  display: block;
  border: 0;
`;
